import { css, styled } from 'styled-components';

export const Card = styled.button<{ $type: string }>`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${({ theme }) => theme.neutral_100};
  border: 1px solid ${({ theme }) => theme.neutral_200};
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.neutral_500};
  }

  ${({ theme, $type }) => {
    const typeColor =
      theme.dashboardCardType[$type] || theme.dashboardCardType['default'];

    return css`
      .fg-status-color {
        color: ${typeColor};
      }
      .bg-status-color {
        background-color: ${typeColor};
      }
    `;
  }};
`;

export const CartTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  .title {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .danger-icon {
    color: ${({ theme }) => theme.danger_500};
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const CardWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: start;
  flex-direction: column;
  padding: 16px;
  gap: 8px;
`;

export const BackgroundIcon = styled.div`
  position: absolute;
  right: -10px;
  top: -10px;
  color: ${({ theme }) => theme.neutral_200};
  z-index: 0;
  pointer-events: none;

  svg {
    width: 100px;
    height: 100px;
  }
`;

export const CardBottomLine = styled.div`
  height: 4px;
  width: 100%;
  background-color: red;
`;

export const AnchorStyle = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  background-color: transparent;
  color: ${({ theme }) => theme.primary_300};
`;
